<template>
    <header class="consulta-header" style="padding-bottom: 0px">
        <div class="header-new-palette">
            <div class="col-4 align-self-start">
                <a href="https://fiscalizacion.ine.mx/web/portalsif/inicio" target=”_blank”>
                    <img class="img-header-new-palette" src="../assets/images/header_rendicion_logo.svg" />
                </a>
                <!--<img class="consulta-header-icon-line" src="../assets/images/header-icon-line.svg" />-->
            </div>
            <div class="col-6">
                &nbsp;
            </div>
            <div class="col-2 contacto-new-palette">
                <a href="https://fiscalizacion.ine.mx/web/portalsif/contacto" target=”_blank”>
                    <img class="img-contacto-new-palette" src="../assets/images/contacto_con_icono.svg" />
                </a>
            </div>
        </div>


    </header>
</template>
<script>
export default {
    name: 'HeaderComponent'
}
</script>